// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconAlertCircle = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      className: 'ionicon',
      viewBox: '0 0 512 512',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z',
      fill: 'none',
      stroke: 'current',
      strokeMiterlimit: '10',
      strokeWidth: '32'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z',
      fill: 'none',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '32'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z'
    })
  );

export { IconAlertCircle };
